import React from 'react'
import PageHeader from '../components/PageHeader'
import { useText } from '../context/TextContext'
import { Col, Row } from 'react-bootstrap'
import { SUPPORT_EMAIL } from '../utils/shared/constants'

export default function SupportPage() {
    const text = useText()

    const faqs = [
        {
            question: text.faqCreateDealQ,
            answer: text.faqCreateDealA
        },
        {
            question: text.faqAddTeamMembersQ,
            answer: text.faqAddTeamMembersA
        },
        {
            question: text.faqAttachFilesQ,
            answer: text.faqAttachFilesA
        },
        {
            question: text.faqMapViewQ,
            answer: text.faqMapViewA
        },
        {
            question: text.faqSendEstimatesQ,
            answer: text.faqSendEstimatesA
        }
    ]

    return (
        <>
            <PageHeader
                title={text.support}
                description={text.supportDescription}
                showBackButton
            />

            <div className="mb-5">
                <div className="text-center mb-4">
                    <h4 className="mb-3">{text.contactSupport}</h4>
                    <p className="text-muted mb-3">
                        {text.supportEmailDescription}
                    </p>
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
                        <i className="bi bi-envelope text-primary"></i>
                        <strong>{text.emailUs}</strong>
                        <a
                            href={`mailto:${SUPPORT_EMAIL}`}
                            className="text-primary text-decoration-none"
                        >
                            {SUPPORT_EMAIL}
                        </a>
                    </div>
                    <p className="small text-muted">
                        {text.responseTime}
                    </p>
                </div>
            </div>

            <Row>
                <Col md={10} className="mx-auto">
                    <h4 className="mb-4">{text.frequentlyAskedQuestions}</h4>

                    <div className="d-flex flex-column gap-4">
                        {faqs.map((faq, index) => (
                            <div key={index}>
                                <h6 className="text-primary mb-2">
                                    <i className="bi bi-question-circle me-2"></i>
                                    {faq.question}
                                </h6>
                                <p className="text-muted ps-4">
                                    {faq.answer}
                                </p>
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>

            <Row className="mt-5">
                <Col md={8} className="mx-auto text-center">
                    <div className="p-4">
                        <h6 className="mb-2">{text.stillNeedHelp}</h6>
                        <p className="text-muted mb-3">
                            {text.stillNeedHelpDescription}
                        </p>
                        <a
                            href={`mailto:${SUPPORT_EMAIL}?subject=ArbTask Support Request`}
                            className="btn btn-primary"
                        >
                            <i className="bi bi-envelope me-2"></i>
                            {text.supportSendEmail}
                        </a>
                    </div>
                </Col>
            </Row>
        </>
    )
}